module.exports = __webpack_public_path__ + "static/media/token_ufo_200.e9326163.png";